import { render, staticRenderFns } from "./purchaserCard.vue?vue&type=template&id=61b51180&scoped=true"
import script from "./purchaserCard.vue?vue&type=script&lang=js"
export * from "./purchaserCard.vue?vue&type=script&lang=js"
import style0 from "./purchaserCard.vue?vue&type=style&index=0&id=61b51180&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b51180",
  null
  
)

export default component.exports